import Paper from '@material-ui/core/Paper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import { GRAY_COLORS } from 'asterX-UI/colors.constant'
import * as PropTypes from 'prop-types'

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: GRAY_COLORS[50],
    color: GRAY_COLORS[600],
    padding: 10
  },
  body: {
    padding: 10,
    whiteSpace: 'nowrap',
    color: GRAY_COLORS[600],
    fontSize: 14
  }
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
  root: {
    padding: '12px 0',
    cursor: props => {
      if (props?.clickable) {
        return 'pointer'
      }

      return 'default'
    },
    '&:hover': {
      backgroundColor: props => {
        if (props?.clickable) {
          return GRAY_COLORS[200]
        }

        return ''
      }
    }
  }
}))(TableRow)

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
})

export default function StandardTable({
  tableData,
  tableStyles,
  onRowClick = () => {}
}) {
  const classes = useStyles()

  return (
    <TableContainer component={Paper} style={tableStyles}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            {tableData.names.map((name, i) => (
              <StyledTableCell key={`styled_name_${i}`}>{name}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {tableData.rows.map((row, i) => (
            <StyledTableRow
              key={`styled_row_${i}`}
              clickable={!!onRowClick}
              onClick={() => onRowClick(row)}
            >
              {row.map((val, j) => (
                <StyledTableCell key={`styled_cell_${j}`}>
                  {val}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

StandardTable.propTypes = {
  tableData: PropTypes.shape({
    names: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired
  }).isRequired
}
